import countries from "constants/countries";

const NO_COUNTRY = "NO_COUNTRY";
const NO_COUNTRY_TEXT = "No Country";

const NO_COUNTRY_OPTION = {
  key: NO_COUNTRY,
  value: NO_COUNTRY,
  text: NO_COUNTRY_TEXT,
};

function getCountryByCode(code) {
  if (code === NO_COUNTRY) {
    return NO_COUNTRY_OPTION;
  }
  return (
    code &&
    countries.COUNTRY_OPTIONS.find(country => {
      return country.value === code;
    })
  );
}

export { getCountryByCode, NO_COUNTRY, NO_COUNTRY_TEXT, NO_COUNTRY_OPTION };
